import { render, staticRenderFns } from "./VuetifySidebar.vue?vue&type=template&id=5a1e968b&scoped=true&"
import script from "./VuetifySidebar.vue?vue&type=script&lang=js&"
export * from "./VuetifySidebar.vue?vue&type=script&lang=js&"
import style0 from "./VuetifySidebar.vue?vue&type=style&index=0&id=5a1e968b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e968b",
  null
  
)

export default component.exports